module.exports = __webpack_public_path__ + "img/salePunch.39f8da12.png";